import { ActionContext, ActionTree, GetterTree, MutationTree } from 'vuex';
import { RootState } from '@/store';
import PlaceDate from '@/utils/placeDate';
import SystemDate from '@/utils/systemDate';
import { ONE_SECOND_IN_MILLISECONDS } from '@/utils/format/date';

const namespaced: boolean = true;

// Расхождение в пределах этого значения считаем сетевой задержкой, а не рассинхроном часов
const SERVER_TIME_DIFF_TOLERANCE_IN_SECONDS: number = 1;

let timerId: number | null = null;

function getClientUtcNowInSeconds(): number {
  return Math.floor(Date.now() / ONE_SECOND_IN_MILLISECONDS);
}

export interface TimerState {
  utcNowInSeconds: number,
  serverTimeDiffInSeconds: number,
  today: SystemDate,
}

const state: TimerState = {
  utcNowInSeconds: getClientUtcNowInSeconds(),
  serverTimeDiffInSeconds: 0,
  today: new SystemDate().getStartOfDay(),
};

const getters: GetterTree<TimerState, RootState> = {
  nowDate(state, getters): PlaceDate {
    return new PlaceDate(getters.nowInSelectedPlaceInSeconds);
  },
  nowInSelectedPlaceInSeconds(state, getters, rootState: any) {
    if (rootState.place.selectedPlace !== null) {
      return state.utcNowInSeconds + rootState.place.selectedPlace.timezone;
    }

    return state.utcNowInSeconds;
  },
  currentYear(state, getters) {
    return getters.nowDate.getFullYear();
  }
};

const actions: ActionTree<TimerState, RootState> = {
  startTimer(
    { commit, dispatch, state }: ActionContext<TimerState, RootState>,
    serverUtcNowInSeconds: number
  ) {
    if (Number.isFinite(serverUtcNowInSeconds) && serverUtcNowInSeconds > 0) {
      const diffInSeconds = serverUtcNowInSeconds - getClientUtcNowInSeconds();

      if (Math.abs(diffInSeconds - state.serverTimeDiffInSeconds) > SERVER_TIME_DIFF_TOLERANCE_IN_SECONDS) {
        commit('setServerTimeDiffInSeconds', diffInSeconds);
      }
    }

    dispatch('syncNow');

    if (timerId === null) {
      timerId = window.setInterval(() => dispatch('syncNow'), ONE_SECOND_IN_MILLISECONDS);
    }
  },
  syncNow({ commit, getters, state }: ActionContext<TimerState, RootState>) {
    commit('setNow', getClientUtcNowInSeconds() + state.serverTimeDiffInSeconds);

    const now = new PlaceDate(getters.nowInSelectedPlaceInSeconds);

    if (!now.isSameDays(state.today)) {
      commit('setToday', now.getStartOfDay());
    }
  }
};

const mutations: MutationTree<TimerState> = {
  setNow(state: TimerState, utcNowInSeconds: number) {
    state.utcNowInSeconds = utcNowInSeconds;
  },
  setServerTimeDiffInSeconds(state: TimerState, serverTimeDiffInSeconds: number) {
    state.serverTimeDiffInSeconds = serverTimeDiffInSeconds;
  },
  setToday(state: TimerState, today: SystemDate) {
    state.today = today;
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
